import { getMeasure } from '../performance';
import { resolvedEvent, unresolvedEvent } from './analytics';
export { ANALYTICS_CHANNEL, context, fireSmartLinkEvent, resolvedEvent, unresolvedEvent, invokeSucceededEvent, invokeFailedEvent, chunkloadFailedEvent, connectSucceededEvent, connectFailedEvent, trackAppAccountAuthStarted, trackAppAccountConnected, uiAuthEvent, uiAuthAlternateAccountEvent, uiCardClickedEvent, uiActionClickedEvent, uiClosedAuthEvent, screenAuthPopupEvent, uiRenderSuccessEvent, uiRenderFailedEvent, uiHoverCardViewedEvent, uiHoverCardDismissedEvent, uiHoverCardOpenLinkClickedEvent, uiLearnMoreLinkClickedEvent, uiIframeDwelledEvent, uiSmartLinkStatusLozengeButtonClicked, uiSmartLinkStatusListItemButtonClicked, uiSmartLinkStatusOpenPreviewButtonClicked } from './analytics';
export const instrumentEvent = ({
  id,
  status,
  extensionKey,
  definitionId,
  resourceType,
  destinationProduct,
  destinationSubproduct,
  location,
  error
}) => {
  const measure = getMeasure(id, status) || {
    duration: undefined
  };
  if (status === 'resolved') {
    const event = resolvedEvent({
      id,
      extensionKey,
      definitionId,
      resourceType,
      destinationProduct,
      destinationSubproduct,
      location
    });
    return {
      ...event,
      attributes: {
        ...event.attributes,
        duration: measure.duration
      }
    };
  } else {
    if ((error === null || error === void 0 ? void 0 : error.type) !== 'ResolveUnsupportedError') {
      const event = unresolvedEvent({
        id,
        status,
        extensionKey,
        definitionId,
        resourceType,
        destinationProduct,
        destinationSubproduct,
        location,
        error
      });
      return {
        ...event,
        attributes: {
          ...event.attributes,
          duration: measure.duration
        }
      };
    }
  }
};